module.exports = __webpack_public_path__ + "static/media/p_15_0.357d28aa.png";